import React from 'react';

const About = () => (
  <section id="about" className="container my-5">
    <div className="card shadow-sm p-4">
      <h2 className="mb-3">About</h2>
      <p>FullStackDev.info is dedicated to helping aspiring and experienced developers become proficient full stack developers. Our mission is to provide clear, practical, and up-to-date resources for every step of your journey.</p>
    </div>
  </section>
);

export default About; 